import { connect } from 'react-redux'
import OauthCallback from './oauth-callback'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import {
  twitterConnectCallback,
  o365ConnectCallback
} from 'pobble-components/dist/oauth'
import { errorHandler } from 'pobble-components/dist/error-handler'

const callbacksMap = {
  twitter: twitterConnectCallback,
  o365: o365ConnectCallback
}

const mapDispatchToProps = (dispatch, { location, history, match }) => ({
  onMount: () => {
    const PROVIDER = match.params.provider
    const PARAMS = qs.parse(location.search, { ignoreQueryPrefix: true })
    callbacksMap[PROVIDER](PARAMS, 'account')
      .then(res => history.push('/'))
      .catch(e => {
        e !== 'CANCEL' && errorHandler(e)
        history.push('/')
      })
  }
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(OauthCallback)
)
